(function() {
    var dateOptions = {
        changeMonth: true,
        changeYear: true,
        altFormat: "yy-mm-dd",
        dateFormat:'dd/mm/yy',
        showButtonPanel: true,
    }

    var startOptions = {
        altField: 'input[name=start_date]',
        onClose: function(dateText, inst) { 
            $(this).datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1))
        }
    }

    var endOptions = {
        altField: 'input[name=end_date]',
        onClose: function(dateText, inst) { 
            $(this).datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth + 1, 0))
        }
    }

    $('.report-dates').each(function () {
        var $el = $(this)
        $el.find('.start-date-display').datepicker($.extend(dateOptions, startOptions))
        $el.find('.end-date-display').datepicker($.extend(dateOptions, endOptions))
    })
})()
